// src/data/navItems.js
export const navItems = [
  {
    path: "/about",
    label: "About",
    icon: {
      name: "TbUserCode",
      prefix: "tb",
    },
  },
  {
    path: "/skills",
    label: "Skills",
    icon: {
      name: "IoCogOutline",
      prefix: "io",
    },
  },
  {
    path: "/projects",
    label: "Projects",
    icon: {
      name: "LiaLaptopCodeSolid",
      prefix: "lia",
    },
  },
  {
    path: "/contact",
    label: "Contact",
    icon: {
      name: "MdOutlineContactPage",
      prefix: "md",
    },
  },
];
